/**
 * What a load of QA state describes, as one comparable value (ORB-982).
 *
 * The asset review overlay holds four pieces of QA state — the run, whether it is loading, a load
 * error, and this key — and decides at RENDER time whether they describe what is on screen. The key is
 * what that decision compares, so what goes into it is what the overlay is able to notice has changed.
 *
 * ⚑⚑ Both the version AND whether QA applies. The version alone was not enough: revoking a reader's
 * access leaves the key agreeing, so state fetched while QA was visible was treated as describing the
 * moment after — and the verdict stayed on screen for a paint. Granting access has the mirror problem,
 * reporting "has not been checked" before the fetch has started. A QA verdict on an asset under review
 * is the one value that must never be briefly wrong. Raised by Copilot on PR 243.
 *
 * ⚑ One string rather than two pieces of state that move together. Half-updating the pair is the exact
 * failure the render-time match exists to prevent, so the pair is not available to get wrong.
 */
export const qaStateKey = (applies: boolean, versionId: string | undefined): string =>
    `${applies ? 'applies' : 'hidden'}:${versionId ?? 'no-version'}`
